import { render, staticRenderFns } from "./veSbzcCdCategory.vue?vue&type=template&id=25f543f8&scoped=true"
import script from "./veSbzcCdCategory.vue?vue&type=script&lang=js"
export * from "./veSbzcCdCategory.vue?vue&type=script&lang=js"
import style0 from "./veSbzcCdCategory.vue?vue&type=style&index=0&id=25f543f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f543f8",
  null
  
)

export default component.exports